export default __webpack_public_path__ + "static/media/engine.3a13db80.png";